import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Width } from '@figure/frontlib-gui';
import { useCreateObjectURL } from '../hooks/useCreateObjectURL';

export const UploadPreviewWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 2px;
  border-width: 0 1px 1px 1px;
  flex-direction: column;
  overflow: hidden;
`;

export const UploadPreview = styled.img`
  max-height: 260px;
  object-fit: scale-down;

  width: inherit;
  height: 170px;
  max-width: calc(${Width.SM}px - 190px);
  @media print, screen and (max-width: ${Width.SM}px) {
    height: 260px;
  }
`;

export const UploadedFilePreview = ({ file, className }) => {
  const { url, onLoad } = useCreateObjectURL(file);

  if (!file) return null;
  return (
    <UploadPreviewWrapper className={className}>
      <UploadPreview
        src={url}
        width="500"
        height="200"
        onLoad={onLoad}
        className="fs-exclude"
        {...(file.type.includes('pdf') ? { as: 'embed' } : { alt: file.name })}
      />
    </UploadPreviewWrapper>
  );
};

UploadedFilePreview.defaultProps = {
  file: null,
  className: '',
};
UploadedFilePreview.propTypes = {
  file: PropTypes.object,
  className: PropTypes.string,
};
